import { Tool } from './Tool';
export class LocateTool extends Tool {
    constructor() {
        super('Locate', new URL('../../assets/loc.svg', import.meta.url).href);
        this.isLocated = false;
        this.marker = null;
    }
    execute(mapInstance, mapLib = null) {
        if (!mapInstance) {
            console.warn('Map instance is not available.');
            return;
        }
        if (!navigator.geolocation) {
            alert('Geolocation is not supported by your browser.');
            return;
        }
        if (this.isLocated) {
            this.isLocated = false;
            // delete existing location markers if needed
            if (this.marker) {
                this.marker.remove();
                this.marker = null;
            }
            return;
        }
        this.isLocated = true;
        navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            mapInstance.flyTo({
                center: [longitude, latitude],
                zoom: 14,
                essential: true,
            });
            // Marker
            const svgMarker = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svgMarker.setAttribute('width', '24');
            svgMarker.setAttribute('height', '24');
            svgMarker.setAttribute('viewBox', '0 0 24 24');
            svgMarker.innerHTML = `
                    <style>
                        .pulse {
                            transform-origin: center;
                            animation: pulse 1.2s infinite ease-in-out;
                        }

                        @keyframes pulse {
                            0% { transform: scale(1); opacity: 0.7; }
                            50% { transform: scale(1.5); opacity: 0.3; }
                            100% { transform: scale(1); opacity: 0.7; }
                        }
                    </style>
                    <!-- Cercle extérieur animé -->
                    <circle cx="12" cy="12" r="8" fill="#007AFF" class="pulse"/>
                    <!-- Cercle central -->
                    <circle cx="12" cy="12" r="4" fill="white" stroke="#007AFF" stroke-width="2"/>
                `;
            this.marker = new mapLib.Marker({ element: svgMarker })
                .setLngLat([longitude, latitude])
                .addTo(mapInstance);
        }, (error) => {
            alert(`Unable to retrieve your location: ${error.message}`);
        });
    }
}
//# sourceMappingURL=LocateTool.js.map